import React from 'react';
import { 
  Box, 
  Container, 
  Grid, 
  Typography, 
  Link, 
  Divider,
  IconButton,
  Stack
} from '@mui/material';
import { 
  Facebook, 
  Twitter, 
  LinkedIn, 
  Instagram,
  Copyright
} from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <Box 
      component="footer" 
      sx={{ 
        bgcolor: '#0b1c30', 
        color: 'white',
        py: 6,
        mt: 'auto'
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Contract AI
            </Typography>
            <Typography variant="body2" color="rgba(255,255,255,0.7)" sx={{ mb: 2 }}>
              AI-powered legal document generation and analysis platform.
            </Typography>
            <Stack direction="row" spacing={1}>
              <IconButton size="small" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                <Facebook />
              </IconButton>
              <IconButton size="small" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                <Twitter />
              </IconButton>
              <IconButton size="small" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                <LinkedIn />
              </IconButton>
              <IconButton size="small" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                <Instagram />
              </IconButton>
            </Stack>
          </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              Product
            </Typography>
            <Box component="ul" sx={{ p: 0, m: 0, listStyle: 'none' }}>
              <Box component="li" sx={{ mb: 1 }}>
                <Link component={RouterLink} to="/features" color="inherit" underline="hover" sx={{ opacity: 0.7 }}>
                  Features
                </Link>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Link component={RouterLink} to="/how-it-works" color="inherit" underline="hover" sx={{ opacity: 0.7 }}>
                  How It Works
                </Link>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Link component={RouterLink} to="/pricing" color="inherit" underline="hover" sx={{ opacity: 0.7 }}>
                  Pricing
                </Link>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Link component={RouterLink} to="/templates" color="inherit" underline="hover" sx={{ opacity: 0.7 }}>
                  Templates
                </Link>
              </Box>
            </Box>
          </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              Resources
            </Typography>
            <Box component="ul" sx={{ p: 0, m: 0, listStyle: 'none' }}>
              <Box component="li" sx={{ mb: 1 }}>
                <Link component={RouterLink} to="/blog" color="inherit" underline="hover" sx={{ opacity: 0.7 }}>
                  Blog
                </Link>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Link component={RouterLink} to="/documentation" color="inherit" underline="hover" sx={{ opacity: 0.7 }}>
                  Documentation
                </Link>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Link component={RouterLink} to="/support" color="inherit" underline="hover" sx={{ opacity: 0.7 }}>
                  Support
                </Link>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Link component={RouterLink} to="/faq" color="inherit" underline="hover" sx={{ opacity: 0.7 }}>
                  FAQ
                </Link>
              </Box>
            </Box>
          </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              Company
            </Typography>
            <Box component="ul" sx={{ p: 0, m: 0, listStyle: 'none' }}>
              <Box component="li" sx={{ mb: 1 }}>
                <Link component={RouterLink} to="/about" color="inherit" underline="hover" sx={{ opacity: 0.7 }}>
                  About Us
                </Link>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Link component={RouterLink} to="/contact" color="inherit" underline="hover" sx={{ opacity: 0.7 }}>
                  Contact
                </Link>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Link component={RouterLink} to="/careers" color="inherit" underline="hover" sx={{ opacity: 0.7 }}>
                  Careers
                </Link>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Link component={RouterLink} to="/privacy" color="inherit" underline="hover" sx={{ opacity: 0.7 }}>
                  Privacy Policy
                </Link>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Link component={RouterLink} to="/terms" color="inherit" underline="hover" sx={{ opacity: 0.7 }}>
                  Terms of Service
                </Link>
              </Box>
            </Box>
          </Grid>
        </Grid>
        
        <Divider sx={{ borderColor: 'rgba(255,255,255,0.1)', my: 4 }} />
        
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
          <Typography variant="body2" color="rgba(255,255,255,0.7)" sx={{ display: 'flex', alignItems: 'center' }}>
            <Copyright fontSize="small" sx={{ mr: 0.5 }} />
            {currentYear} Contract AI. All rights reserved.
          </Typography>
          <Box>
            <Link component={RouterLink} to="/privacy" color="inherit" underline="hover" sx={{ opacity: 0.7, mr: 2, fontSize: '0.875rem' }}>
              Privacy
            </Link>
            <Link component={RouterLink} to="/terms" color="inherit" underline="hover" sx={{ opacity: 0.7, mr: 2, fontSize: '0.875rem' }}>
              Terms
            </Link>
            <Link component={RouterLink} to="/cookies" color="inherit" underline="hover" sx={{ opacity: 0.7, fontSize: '0.875rem' }}>
              Cookies
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 